import { ManageUsersCardsContainer } from './ManageUser.styles';
import { Product } from '@Types/product.types';
import React from 'react';
import SubscriptionCard from '@Components/SubscriptionCard';
import { User } from '@Types/user.types';
import useInternalUser from '../../hooks/useInternalUser';

interface ManageUsersCardsProps {
	subscription?: Product;
	newExternalUsers: User[];
	newInternalUsers: User[];
}

export default function ManageUsersCards({
	newExternalUsers,
	subscription,
	newInternalUsers,
}: ManageUsersCardsProps) {
	const isInternalUser = useInternalUser();
	return (
		<ManageUsersCardsContainer>
			<SubscriptionCard
				product={subscription}
				height={50}
				numberOfSubscriptionsUsed={newExternalUsers.length}
			/>
			{isInternalUser && (
				<SubscriptionCard
					product={subscription}
					height={50}
					numberOfSubscriptionsUsed={newInternalUsers.length}
					forceDisableMaxEntitlements
					title="Internal Autodesk Users"
				/>
			)}
		</ManageUsersCardsContainer>
	);
}
